import type { ReactToLit } from '@affine/component';
import { AttachmentViewer } from '@affine/core/blocksuite/attachment-viewer';
import { isEditableTextAttachment } from '@affine/core/blocksuite/attachment-viewer/utils';
import { AttachmentEmbedConfigIdentifier } from '@blocksuite/affine/blocks/attachment';
import { Bound } from '@blocksuite/affine/global/gfx';
import {
  EMBED_CARD_HEIGHT,
  EMBED_CARD_WIDTH,
} from '@blocksuite/affine/shared/consts';
import type { ExtensionType } from '@blocksuite/affine/store';

const TEXT_ATTACHMENT_PREVIEW_MAX_BYTES = 1024 * 1024;

/** Use the same editable viewer for a canvas embed and a fullscreen file. */
export function patchForTextEmbedView(reactToLit: ReactToLit): ExtensionType {
  return {
    setup: di => {
      di.override(AttachmentEmbedConfigIdentifier('text'), () => ({
        name: 'text',
        shouldShowStatus: true,
        check: model =>
          isEditableTextAttachment({
            mimeType: model.props.type,
            name: model.props.name,
          }) && model.props.size <= TEXT_ATTACHMENT_PREVIEW_MAX_BYTES,
        action: model => {
          const bound = Bound.deserialize(model.props.xywh);
          bound.w = EMBED_CARD_WIDTH.html;
          bound.h = EMBED_CARD_HEIGHT.html;
          model.store.updateBlock(model, {
            embed: true,
            style: 'html',
            xywh: bound.serialize(),
          });
        },
        render: (model, _, context) =>
          reactToLit(
            <AttachmentViewer
              model={model}
              std={context.std}
              hideTitlebarClose
            />,
            true
          ),
      }));
    },
  };
}
